import useQuestionsQuery from '../questions/useQuery';
import useInvitationsQuery from '../invitations/useQuery';
import useClaimsQuery from '../claims/useQuery';
import { PayloadStates } from '@lore/utils';

export default function useQuery(props) {
  const questions = useQuestionsQuery(props);
  const invitations = useInvitationsQuery(props);
  const claims = useClaimsQuery(props);

  if (
    questions.state !== PayloadStates.RESOLVED ||
    invitations.state !== PayloadStates.RESOLVED ||
    claims.state !== PayloadStates.RESOLVED
  ) {
    return {
      state: PayloadStates.FETCHING,
      data: [],
      meta: undefined
    };
  }

  return {
    state: PayloadStates.RESOLVED,
    data: [].concat(
      questions.data,
      invitations.data,
      claims.data
    ),
    meta: {
      totalCount: (
        (questions.meta?.totalCount || 0) +
        (invitations.meta?.totalCount || 0) +
        (claims.meta?.totalCount || 0)
      )
    }
  };
}
